const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content host Assignmentscomponent
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('contentHostViews', ['Application', 'AccessHelper', 'Analyze', 'Users', 'AdminUsers', '$q', '$window', '$translate', function(Application, AccessHelper, Analyze, Users, AdminUsers, $q, $window, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      template: require('../../templates/directives/content-host-views.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.filter = {};
          self.page = null;
          self.per_page = 20;
          self.translations = {};
          self.userDirectory = {};

          self.allowance = {
            restricted_access: AccessHelper.isAllowed(['admin', 'users', 'restricted_access'], null, ['admin', 'manager', 'creator'])
          };

          var params = Application.navigation.getRouteParameters();
          self.contentId = params.id;

          self.parseUrl = function() {
            var url = Application.navigation.getPath();
            if (/articles/g.test(url)) {
              return 'article';
            }
            if (/videos/g.test(url)) {
              return 'video';
            }
            if (/files/g.test(url)) {
              return 'file';
            }
            if (/scorm/g.test(url)) {
              return 'scorm';
            }
            if (/imported-content/g.test(url)) {
              return 'imported_content';
            }
            if (/presentations/g.test(url)) {
              return 'presentations';
            }
            return null;
          };

          self.contentType = self.parseUrl();

          self.smart_filter = {};
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }

              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id]._id.toString());
              }
              self.searchItems.csv_selected += '&users=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };
          self.searchItems = {
            placeholder: self.translations['contentHostViews.search_placeholder'],
            onQuery: function(query_arguments) {
              self.smart_filter = {};
              self.searching = false;

              if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
                self.filter = {content: self.contentId};
                self.loadItems();
                return;
              }

              for (var key in query_arguments) {
                self.smart_filter[key] = query_arguments[key];
              }

              var user_filter = {
                fields: 'first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                page: 1,
                per_page: 50,
                prioritize_creator: true
              };
              if (self.smart_filter.privacy_locations) {
                user_filter.linked_locations = self.smart_filter.privacy_locations;
              }
              if (self.smart_filter.privacy_departments) {
                user_filter.linked_departments = self.smart_filter.privacy_departments;
              }
              if (self.smart_filter.privacy_teams) {
                user_filter.linked_teams = self.smart_filter.privacy_teams;
              }
              if (self.smart_filter.privacy_org_levels) {
                user_filter.linked_org_level = self.smart_filter.privacy_org_levels;
              }
              if (self.smart_filter.privacy_grades) {
                user_filter.linked_grade = self.smart_filter.privacy_grades;
              }
              if (self.smart_filter.groups) {
                user_filter.groups = self.smart_filter.groups;
              }
              if (self.smart_filter.name) {
                user_filter.full_name = self.smart_filter.name;
              }
              if (self.smart_filter['$or']) {
                user_filter['$or'] = self.smart_filter['$or'];
              }
              self.searching = true;
              self.searchLoading = true;

              AdminUsers.find(user_filter).$promise.then(function(users) {
                var ids = users.map(function(user) {
                  self.userDirectory[user._id] = user;
                  return user._id;
                });
                var length = ids.length;
                ids = ids.join(',');

                self.page = 0;
                self.filter.user = '$in,' + length + ',' + ids;
                self.loadItems();
              });
            },
            csv_filtered: '',
            csv_selected: ''
          };
          self.filter.content = self.contentId;
          self.nextPage = function(force) {
            if (!self.page || self.page === -1) {
              self.page = 0;
            }
            self.page++;
            self.paginated_views = self.views.slice((self.page -1) * self.per_page, (self.page) * self.per_page);
            if (self.page > 1) {
              self.allowPrevious = true;
            }
            if((((self.page -1) * self.per_page) + self.per_page) >= self.views.length) {
              self.allowNext = false;
            }
            if (force === true || !self.views || self.views.length === 0) {
              self.page = 1;
              self.loadItems();
            }
          };
          self.previousPage = function(force) {
            if (!self.page || self.page < 2) {
              self.page = 2;
            }
            self.page--;
            self.paginated_views = self.views.slice((self.page -1) * self.per_page, (self.page) * self.per_page);
            if (self.page === 1) {
              self.allowPrevious = false;
            }
            if((((self.page -1) * self.per_page) + self.per_page) < self.views.length) {
              self.allowNext = true;
            }
            if (force === true || !self.views || self.views.length === 0) {
              self.page = 0;
              self.loadItems();
            }
          };
          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };
          self.getUserNames = function(userIds) {
            var length = 0;
            var ids = null;
            angular.forEach(userIds, function(id) {
              if (!self.userDirectory[id]) {
                length++;
                if (!ids) {
                  ids = '' + id;
                  return;
                }
                ids += ',' + id;
              }
            });
            return Users.specialSearch({}, {
              fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
              'linked_locations-populate': 'name',
              'linked_departments-populate': 'name',
              _id: '$in,' + length + ',' + ids
            }).$promise;
          };

          var restictedList = '';
          usersChecked = false;
          var aggregateUsers = function() {
            var deferred = $q.defer();
    
            if (!self.allowance.restricted_access || usersChecked) {
              deferred.resolve();
              return deferred.promise;
            }

            AdminUsers.find({fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
              'linked_locations-populate': 'name',
              'linked_departments-populate': 'name',
              per_page: 300,
              prioritize_creator: true
            }).$promise.then(function(users) {
              var list = [];
              users.forEach(function(user) {
                list.push(user._id);
                self.userDirectory[user._id] = user;
              });
              restictedList = '$in,' + list.length + ',' + list.join(',');
              usersChecked = true
              deferred.resolve();
            });

            return deferred.promise;
          }
          self.loadItems = function() {
            self.searchLoading = true;
            aggregateUsers()
            .then(function(users) {
              if (self.allowance.restricted_access) {
                self.filter.users = restictedList;
              }

              Analyze.aggregateViews({itemid: self.filter.content}, self.filter).$promise.then(function(records) {
                var ids = {};
                self.allowNext = true;
                self.allowPrevious = true;
                if (records.length < self.per_page) {
                  self.allowNext = false;
                }
                if (self.page < 2) {
                  self.allowPrevious = false;
                }

                angular.forEach(records, function(item) {
                  ids[item.user] = true;
                });

                if (self.allowance.restricted_access) {
                  self.views = records.filter(function(record) {
                    return self.userDirectory[record.user] !== undefined;
                  });
                  self.paginated_views = self.views.slice(0, 1 * self.per_page);
                  self.reports.createCSV();
                  self.searchLoading = false;
                  return;
                }

                self.getUserNames(Object.keys(ids)).then(function(users) {
                  angular.forEach(users, function(user) {
                    self.userDirectory[user._id] = user;
                  });
                  self.views = records.filter(function(record) {
                    return self.userDirectory[record.user] !== undefined;
                  });
                  self.paginated_views = self.views.slice(0, 1 * self.per_page);
                  self.reports.createCSV();
                  self.searchLoading = false;
                });
              });
            });
          };
          self.reports = {
            csv_filtered: '',
            csv_selected: '',
            csv_dataset_downloadurl: '',
            createCSV: function() {
              var report_data = ['"' + self.translations['global.forms.labels_name'] + '","' + self.translations['global.forms.labels_location'] + '","' + self.translations['manage.label_department'] + '","' + self.translations['manage.host.count'] + '","' + self.translations['manage.host.dateViewed'] + '"'];
              self.views.forEach(function(view) {
                var row = '';
                row += '"' + self.userDirectory[view.user].full_name + '",';
                row += '"' + self.getLocation(self.userDirectory[view.user]) + '",';
                row += '"' + self.getDepartment(self.userDirectory[view.user]) + '",';
                row += '' + view.count + ',';
                row += '' + self.slimDate(view.created_on);
                report_data.push(row);
              });


              $window.URL = $window.webkitURL || $window.URL;

              var content_type = 'text/csv';
              var download = 'report.csv';

              var csvFile = new Blob([report_data.join('\n')], {type: content_type});

              self.reports.csv_filtered = $window.URL.createObjectURL(csvFile);
              self.reports.csv_dataset_downloadurl = [content_type, download, self.reports.csv_filtered].join(':');
            },
            createSelectedCSV: function() {
              var report_data = ['"' + self.translations['global.forms.labels_name'] + '","' + self.translations['global.forms.labels_location'] + '","' + self.translations['manage.label_department'] + '","' + self.translations['manage.host.count'] + '","' + self.translations['manage.host.dateViewed'] + '"'];
              self.views.forEach(function(view) {
                var ids = [];
                if (!self.selectionDirectory[view.user]) {
                  return;
                }
                var row = '';
                row += '"' + self.userDirectory[view.user].full_name + '",';
                row += '"' + self.getLocation(self.userDirectory[view.user]) + '",';
                row += '"' + self.getDepartment(self.userDirectory[view.user]) + '",';
                row += '' + view.count + ',';
                row += '' + self.slimDate(view.created_on);
                report_data.push(row);
              });

              $window.URL = $window.webkitURL || $window.URL;

              var content_type = 'text/csv';
              var download = 'report.csv';

              var csvFile = new Blob([report_data.join('\n')], {type: content_type});

              self.reports.csv_selected = $window.URL.createObjectURL(csvFile);
              self.reports.csv_dataset_downloadurl = [content_type, download, self.reports.csv_filtered].join(':');
            }
          };
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }
              self.reports.createSelectedCSV();
            },
            isChecked: function(item) {
              if (!item) {
                return false;
              }
              return self.selectionDirectory[item] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };
          self.slimDate = function(date) {
            return moment(new Date(date)).format('YYYY-MM-DD');
          };
          self.initialize = function() {
            if (!self.contentId || !self.contentType) {
              Application.navigation.goToHome();
              return;
            }
            self.paginated_views = [];
            self.views = [];
            self.nextPage();
          };
          $translate([
            'global.forms.labels_name',
            'global.forms.labels_location',
            'manage.label_department',
            'manage.host.count',
            'manage.host.dateViewed',
            'contentHostViews.search_placeholder'
          ]).then(function(translations) {
            self.translations = translations;
            self.initialize();
          });
        }],
      controllerAs: 'hostViews'
    };
  }]);
